'use client';

import { useMemo, useRef } from 'react';
import { Combobox as ComboboxPrimitive } from '@base-ui/react';
import { ComboboxProvider, ComboboxAnchorProvider } from './combobox-context';

export const Combobox = <Value, Multiple extends boolean | undefined = false>({
  multiple,
  value,
  onValueChange,
  children,
  ...props
}: ComboboxPrimitive.Root.Props<Value, Multiple>) => {
  const contextValue = useMemo(() => ({ multiple }), [multiple]);

  const anchorRef = useRef<HTMLDivElement | null>(null);

  return (
    <ComboboxProvider value={contextValue}>
      <ComboboxAnchorProvider value={anchorRef}>
        <ComboboxPrimitive.Root
          data-slot="combobox"
          multiple={multiple}
          value={value}
          onValueChange={onValueChange}
          {...props}>
          {children}
        </ComboboxPrimitive.Root>
      </ComboboxAnchorProvider>
    </ComboboxProvider>
  );
};

export const ComboboxValue = ({ ...props }: ComboboxPrimitive.Value.Props) => (
  <ComboboxPrimitive.Value data-slot="combobox-value" {...props} />
);

export const ComboboxCollection = ({ ...props }: ComboboxPrimitive.Collection.Props) => (
  <ComboboxPrimitive.Collection data-slot="combobox-collection" {...props} />
);

export const useComboboxFilter = ComboboxPrimitive.useFilter;
